export default class PerfilOrigenModel {

  static BaseForm() {
    return {
      activo: 1,
      nombre: "",
      descripcion: "",
      origenes: []
    };
  }
}
